import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Content = ({ classes, children }) => (
  <div className={classes.drawerContentWrapper} data-drawer-content>
    {children}
  </div>
);

export default withStyles(styles)(Content);
